import React, { useState } from "react";
import "../styles/CaseStudies.css";

import findora from "../assets/findora.svg";
import ayuraBloom from "../assets/ayura-bloom.svg";
import impactSphere from "../assets/impactsphere.svg";
import spiceRouteKitchen from "../assets/spiceroute-kitchen.svg";
import everAfterEvents from "../assets/everafter-events.svg";
import verdantLiving from "../assets/verdant-living.svg";
import horizonAcademy from "../assets/horizon-academy.svg";
import peopleLinkHr from "../assets/peoplelink-hr.svg";
import nexoraDigital from "../assets/nexora-digital.svg";

const CaseStudies = () => {
  const [activeCategory, setActiveCategory] =
    useState("Web Development");

  const categories = [
    "Web Development",
    "Mobile App Development",
    "Digital Marketing",
    "Branding",
    "SEO",
  ];

  const projects = [
    {
      id: 1,
      title: "Findora",
      category: "Web Development",
      description: "A focused search experience designed to help people find useful information faster.",
      image: findora,
    },
    {
      id: 2,
      title: "Ayura Bloom",
      category: "Web Development",
      description: "A warm, content-led digital experience built to make natural wellness easier to explore.",
      image: ayuraBloom,
    },
    {
      id: 3,
      title: "ImpactSphere",
      category: "Web Development",
      description: "A clear, trustworthy website experience that helps a social organisation communicate its work.",
      image: impactSphere,
    },
    {
      id: 4,
      title: "SpiceRoute Kitchen",
      category: "Web Development",
      description: "A bold food brand website designed to bring personality, culture, and easy browsing together.",
      image: spiceRouteKitchen,
    },
    {
      id: 5,
      title: "EverAfter Events",
      category: "Web Development",
      description: "An elegant event experience that helps people discover celebrations and plan memorable moments.",
      image: everAfterEvents,
    },
    {
      id: 6,
      title: "Verdant Living",
      category: "Web Development",
      description: "A clean product-led website created to present natural wellness with clarity and confidence.",
      image: verdantLiving,
    },
    {
      id: 7,
      title: "Horizon Academy",
      category: "Web Development",
      description: "A welcoming education website that makes school information easier for families to explore.",
      image: horizonAcademy,
    },
    {
      id: 8,
      title: "PeopleLink HR",
      category: "Web Development",
      description: "A professional digital presence designed to connect people, teams, and career opportunities.",
      image: peopleLinkHr,
    },
    {
      id: 9,
      title: "Nexora Digital",
      category: "Web Development",
      description: "A focused brand experience built to communicate a modern service with a clear digital identity.",
      image: nexoraDigital,
    },
  ];

  const filteredProjects = projects;

  return (
    <div className="case-studies-page">

      {/* ==============================
          HERO
      =============================== */}

      <section className="case-hero">

        <div className="blue-glow glow-one"></div>
        <div className="blue-glow glow-two"></div>

        <div className="case-hero-content">

          <h1>Case Studies</h1>

          <h2>
            <span className="blue-text">
              Building Solutions, Creating Impact
            </span>
          </h2>

          <p>
            Explore how TechLynx uses innovative technology and
            creative thinking to help businesses grow, improve, and succeed
            in the digital world.
          </p>

        </div>

      </section>


      {/* ==============================
          CASE STUDIES
      =============================== */}

      <section className="case-study-section">

        {/* CATEGORY BUTTONS */}

        <div className="case-category-tabs">

          {categories.map((category) => (
            <button
              key={category}
              className={
                activeCategory === category
                  ? "case-category-btn active"
                  : "case-category-btn"
              }
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}

        </div>


    {/* ==============================
      CASE STUDY CARDS
    =============================== */}

        <div className="case-cards">

          {filteredProjects.length > 0 ? (

            filteredProjects.map((project) => (

              <article
                className="case-card"
                key={project.id}
              >

                {/* CARD TITLE */}

                <div className="case-card-top">

                  <h2>
                    {project.title}
                  </h2>

                  <button
                    className="case-arrow"
                    aria-label="Open case study"
                  >
                    ↗
                  </button>

                </div>


                {/* PROJECT IMAGE */}

                <div className="card-image">

                  <img
                    src={project.image}
                    alt={project.title}
                  />

                </div>


                <p className="case-card-description">
                  {project.description}
                </p>


              </article>

            ))

          ) : (

            <div className="no-projects">

              <h2>
                More Projects Coming Soon
              </h2>

              <p>
                We are preparing more TechLynx
                projects for this category.
              </p>

            </div>

          )}

        </div>

      </section>

    </div>
  );
};

export default CaseStudies;